import toArray from 'lodash/toArray';

/*
    see details https://learn.javascript.ru/string#surrogatnye-pary
    Использование lodash.toArray позволяет корректно считать любые emoji.
    Например:
        [...'👩‍💻🍦🎉'].length === 5; // Не правильно
        toArray('👩‍💻🍦🎉').length === 3 // Правильно
*/
export const getCountEmojiString = (text: string): number => {
    if ('Segmenter' in Intl) {
        const segmenter = new Intl.Segmenter('en', {
            granularity: 'grapheme',
        });

        return [...segmenter.segment(text)].length;
    }

    return toArray(text).length;
};

export const truncateEmojiString = (text: string, maxLength: number): string => {
    if ('Segmenter' in Intl) {
        const segmenter = new Intl.Segmenter('en', {
            granularity: 'grapheme',
        });

        return [...segmenter.segment(text)]
            .slice(0, maxLength)
            .map(segment => segment.segment)
            .join('');
    }

    return toArray(text).slice(0, maxLength).join('');
};
